import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { CensusListService } from 'src/app/includes/census-list/census-list..service';

@Component({
  selector: 'app-rehab-docs-popup',
  templateUrl: './rehab-docs-popup.component.html',
  styleUrls: ['./rehab-docs-popup.component.css']
})
export class RehabDocsPopupComponent implements OnInit {

  documents: any = []
  displayedColumns: string[] = [];
  dataSource: any;
  sort: any;
  paginator: any;
  loading = false;
  fileProgress = 0;
  intervalId: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _censusListService: CensusListService,
  ) {
    this.displayedColumns = ['doc_name', 'doc_type', 'provider', 'facility', 'status'];
  }

  async ngOnInit() {
    await this.loadDocuments();
    const fileStatus = localStorage.getItem('fileProgress');
    if(fileStatus) {
      this.fileProgress = Number(fileStatus);
    }
    this.startInterval();
  }

  async loadDocuments() {
    this.loading = true;
    this._censusListService.getRehabDocs(this.data).subscribe((response: any) => {
      if (response.status == 200) {
        this.documents = response.data;
        this.dataSource = new MatTableDataSource(this.documents);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      }
    })
    this.loading = false;
  }

  ngOnDestroy(): void {
    this.stopInterval();
  }

  stopInterval() {
    clearInterval(this.intervalId);
  }

  startInterval() {
    this.intervalId = setInterval(() => {
      this.loadDocuments();
      if (this.fileProgress < 96) {
        this.fileProgress += 4;
        localStorage.setItem('fileProgress', JSON.stringify( this.fileProgress ));
      }
    }, 10000);
  }

}
